import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ProjectCard from './ProjectCard';
import { projects } from '../data/projects';
import './ProjectScrollReveal.css';

const ProjectScrollReveal = () => (
  <section className="projects-section">
    <div className="container">
      <div className="projects-header">
        <span className="projects-eyebrow">Our Work</span>
        <h2 className="projects-title">Projects we've shipped</h2>
        <p className="projects-subtitle">
          Real products built for colleges and organizations. Open any project to see details.
        </p>
      </div>

      <div className="projects-grid">
        {projects.map((p, idx) => <ProjectCard key={p.slug} project={p} index={idx} />)}
      </div>

      <div className="projects-more">
        <Link to="/products" className="link-arrow">View all products <ArrowRight size={16} /></Link>
      </div>
    </div>
  </section>
);

export default ProjectScrollReveal;
